import { useState } from 'react';
import axios from 'axios';
import { API_URL } from '../utils/api';
import { LEGAL_VERSIONS } from '../pages/LegalPage';
import './ConsentGate.css';

interface Props {
  onComplete: () => void;
  authHeader: Record<string, string>;
}

export default function ConsentGate({ onComplete, authHeader }: Props) {
  const [offer, setOffer] = useState(false);
  const [privacy, setPrivacy] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const canSubmit = offer && privacy && !submitting;

  const handleSubmit = async () => {
    setSubmitting(true);
    setError('');
    try {
      await axios.post(
        `${API_URL}/api/customers/consent`,
        { type: 'OFFER_TERMS', version: LEGAL_VERSIONS.offer },
        { headers: authHeader },
      );
      await axios.post(
        `${API_URL}/api/customers/consent`,
        { type: 'PRIVACY', version: LEGAL_VERSIONS.privacy },
        { headers: authHeader },
      );
      onComplete();
    } catch (e: any) {
      setError(e?.response?.data?.error || 'Не удалось сохранить согласие');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="consent-gate-backdrop">
      <div className="consent-gate-modal">
        <h2>Согласие на использование сервиса</h2>
        <p className="consent-gate-lead">
          Чтобы продолжить пользоваться OLSO, подтвердите согласие с нашими документами.
        </p>

        <label className="consent-gate-row">
          <input type="checkbox" checked={offer} onChange={e => setOffer(e.target.checked)} />
          <span>
            Я принимаю{' '}
            <a href="/legal?tab=offer" target="_blank" rel="noreferrer">Договор оферты</a>
            {' '}и{' '}
            <a href="/legal?tab=terms" target="_blank" rel="noreferrer">Правила пользования</a>
          </span>
        </label>

        <label className="consent-gate-row">
          <input type="checkbox" checked={privacy} onChange={e => setPrivacy(e.target.checked)} />
          <span>
            Согласен на обработку персональных данных согласно{' '}
            <a href="/legal?tab=privacy" target="_blank" rel="noreferrer">Политике конфиденциальности</a>
          </span>
        </label>

        {error && <div className="consent-gate-error">{error}</div>}

        <button
          className="consent-gate-btn"
          disabled={!canSubmit}
          onClick={handleSubmit}
        >
          {submitting ? 'Сохраняем…' : 'Продолжить'}
        </button>
      </div>
    </div>
  );
}
